import React, { useState, useEffect } from 'react';
import { TextField, FormControl, FormControlLabel, RadioGroup, Radio, InputLabel, Select, MenuItem, Button } from '@mui/material';
import axios from 'axios';
import { useAuth } from '../../AuthContext';
import Stack from '@mui/material/Stack';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const NewItemServiceForm = ({ isOpen, onClose, selectedRowData }) => {
  const { userRole } = useAuth()
  const [employee, setEmployee] = useState(true);

  const [uoms, setUOMs] = useState([{ title: '', value: '', price: '' }]);

  const handleUOMChange = (index, key, newValue) => {
    const updatedUOMs = [...uoms];
    updatedUOMs[index][key] = newValue;
    setUOMs(updatedUOMs);
  };

  const handleAddUOM = () => {
    setUOMs([...uoms, { title: '', value: '', price: '' }]);
  };

  const handleRemoveUOM = (index) => {
    const updatedUOMs = [...uoms];
    updatedUOMs.splice(index, 1);
    setUOMs(updatedUOMs);
  };

  useEffect(() => {
    if (userRole === "manager") {
      setEmployee(false)
    } else {
      setEmployee(true)
    };
  }, [userRole])

  const [itemService, setItemService] = useState('');
  const [incomeAmount, setIncomeAmount] = useState('');
  const [rate, setRate] = useState('');
  const [rateSQM, setRateSQM] = useState('');
  const [ratePC, setRatePC] = useState('');
  const [rateSHT, setRateSHT] = useState('');
  const [rateLMTR, setRateLMTR] = useState('');
  const [SHTTOSQR, setSHTTOSQR] = useState('');
  const [currentStock, setCurrentStock] = useState('');
  const [type, setType] = useState('Item');
  const [category, setCategory] = useState('');
  const [CategoryData, setCategoryData] = useState([]);
  const [catId, setCatId] = useState(null);
  const [vendor, setVendor] = useState('');
  const [VendorData, setVendorData] = useState([]);
  const [purchaseDate, setPurchaseDate] = useState('');
  const [AddToStock, setAddToStock] = useState('0');

  const postData = async () => {
    console.log(uoms)
    try {
      if (!itemService || !type ||!catId) {
        toast("EMPTY FIELD");
      } else {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/itemservices/add_itemservice`, {
          "itemservice": itemService,
          "incomeamount": incomeAmount,
          "currentstock": currentStock,
          "rate": rate,
          "rateSQM": rateSQM,
          "ratePC": ratePC,
          "rateSHT": rateSHT,
          "rateLMTR": rateLMTR,
          "type": type,
          "vendor": vendor,
          "purchase_date": purchaseDate,
          "SHTTOSQR": SHTTOSQR,
          "UOM": uoms,
          "categoryid": catId,
          "categoryname": category
        });
        if (response.status === 200) {
          toast.success(`Item/Service created successfully.`)
        }
      }
    } catch (error) { 
      toast.error("Error creating Item/Service") }
  };

  const updateData = async () => {
    if (!itemService || !type) {
      console.log("EMPTY FIELD");
    } else {
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/itemservices/edit_itemservice`, {
        "id": selectedRowData.id,
        "itemservice": itemService,
        "incomeamount": incomeAmount,
        "currentstock": parseInt(currentStock) + parseInt(AddToStock),
        "rate": rate,
        "rateSQM": rateSQM,
        "ratePC": ratePC,
        "rateSHT": rateSHT,
        "rateLMTR": rateLMTR,
        "type": type,
        "vendor": vendor,
        "purchase_date": purchaseDate,
        "SHTTOSQR": SHTTOSQR,
        "categoryid": catId,
        "categoryname": category
      });
      if (response.status === 200) {
        toast.success(`Item/Service updated successfully.`)
      }
    }
  };

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/vendors/all_vendors`);
        const responseData = await response.json();
        if (responseData) {
          setVendorData(responseData.vendor);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/category/all_categories`);
        const responseData = await response.json();
        if (responseData) {
          setCategoryData(responseData.categories);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchCategories();
    fetchVendors();

    if (selectedRowData) {
      setItemService(selectedRowData.itemservice);
      setIncomeAmount(selectedRowData.incomeamount);
      setCurrentStock(selectedRowData.currentstock);
      setRate(selectedRowData.rate);
      setRateSQM(selectedRowData.rateSQM);
      setRatePC(selectedRowData.ratePC);
      setRateSHT(selectedRowData.rateSHT);
      setRateLMTR(selectedRowData.rateLMTR);
      setType(selectedRowData.type);
      setVendor(selectedRowData.vendor_name);
      setPurchaseDate(selectedRowData.purchase_date);
      setSHTTOSQR(selectedRowData.SHTTOSQR || '')
    } else {
      // If no row is selected, clear the form fields
      setItemService('');
      setIncomeAmount('');
      setCurrentStock('');
      setRate('');
      setRateSQM('');
      setRatePC('');
      setRateSHT('');
      setRateLMTR('');
      setType('Item'); // Default to 'Item'
      setVendor('');
      setPurchaseDate('');
      setSHTTOSQR('')
    }
  }, [selectedRowData]);

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedRowData) {
      updateData();
    } else {
      postData();
    }
    setItemService('');
    setIncomeAmount('');
    setCurrentStock('');
    setRate('');
    setRateSQM('');
    setRatePC('');
    setSHTTOSQR('')
    setRateSHT('');
    setRateLMTR('');
    setType('Item'); // Default to 'Item'
    setVendor('');
    setPurchaseDate('');
    onClose();
  };

  return (
    <div className=' max-h-[80vh] overflow-auto' style={{
      display: isOpen ? 'block' : 'none',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      padding: '20px',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
      zIndex: '999',
      backdropFilter: 'blur(5px)',
    }}>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <h2 className='text-2xl font-bold font-poppins ml-2 mt-3 mb-3'>{selectedRowData ? "Update Item/Service" : "Add New Item/Service"}</h2>
      <form onSubmit={handleSubmit}>
        <FormControl component="fieldset" sx={{ mb: 4 }}>
          <RadioGroup
            row
            aria-label="Type"
            name="type"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <FormControlLabel value="Item" control={<Radio />} label="Item" />
            <FormControlLabel value="Service" control={<Radio />} label="Service" />
          </RadioGroup>
        </FormControl>
        {(type === 'Item' || type === 'Service') && (<><TextField
          type="text"
          variant="outlined"
          color="secondary"
          label="Item/Service Name"
          onChange={(e) => setItemService(e.target.value)}
          value={itemService}
          fullWidth
          required
          sx={{ mb: 4 }}
        />
        {CategoryData && (
                <FormControl fullWidth>
                <input
                  list="categories"
                  id="category"
                  value={category}
                  onChange={(e) => {
                    const selectedCategory = CategoryData.find(item => item.categoryname === e.target.value);
                    setCategory(e.target.value);
                    setCatId(selectedCategory ? selectedCategory.id : null);
                  }}
                  placeholder="Type to search categories..."
                  fullWidth
                  sx={{ mb: 4 }}
                />
                <datalist id="categories">
                  {CategoryData?.map((category, index) => (
                    <option key={index} id={category.id} value={category.categoryname}>
                      {`${category.categoryname}`} (ID: {category.id})
                    </option>
                  ))}
                </datalist>
              </FormControl>              
                )}
        </>)}
        {type === 'Item' && (
          <>
            {selectedRowData && employee && (
              <TextField
                type="number"
                variant="outlined"
                color="secondary"
                label="Add Stock"
                onChange={(e) => setAddToStock(e.target.value)}
                value={AddToStock}
                fullWidth
                sx={{ mb: 4 }}
              />
            )}
            {selectedRowData && employee ? (
              <FormControl fullWidth sx={{ display: 'none' }} >
                <InputLabel id="vendor">Vendor</InputLabel>
                <Select
                  labelId="vendor"
                  id="vendor"
                  value={vendor}
                  label="Vendor"
                  onChange={(e) => setVendor(e.target.value)}
                  sx={{ mb: 4 }}
                >
                  {VendorData.map((vendor, index) => (
                    <MenuItem key={index} value={vendor.vendortitle}>
                      {vendor.vendortitle}
                    </MenuItem>
                  ))}

                </Select>
              </FormControl>
            ) : (
              <>

                {VendorData && (<FormControl fullWidth>
                  <input
                    list="vendors"
                    id="vendor"
                    value={vendor}
                    onChange={(e) => setVendor(e.target.value)}
                    placeholder="Type to search vendors..."
                    fullWidth
                    sx={{ mb: 4 }}
                  />
                  <datalist id="vendors">
                    {VendorData?.map((vendor, index) => (
                      <option key={index} value={vendor.vendortitle}>
                        {`${vendor.vendortitle}`} (ID: {vendor.id})
                      </option>
                    ))}
                  </datalist>
                </FormControl>)}

              </>
            )}
            {/* <div className="flex flex-col">
              <label htmlFor="PurchaseDate">Purchase Date</label>
              <input
                type="date"
                name="purchaseDate"
                id="purchaseDate"
                placeholder="Purchase Date"
                autoComplete="off"
                value={purchaseDate}
                onChange={(e) => setPurchaseDate(e.target.value)}
              />
            </div> */}

          </>
        )}
        {/* uom  */}
        <div className="flex flex-col">
          {uoms.map((uom, index) => (
            <Stack sx={{ mb: 2 }} key={index} spacing={2} direction="row">
              <TextField
                label="UOM"
                value={uom.title}
                onChange={(e) => handleUOMChange(index, 'title', e.target.value)}
                variant="outlined"
                color="secondary"
              />
              <TextField
                label="Quantity"
                value={uom.value}
                onChange={(e) => handleUOMChange(index, 'value', e.target.value)}
                variant="outlined"
                color="secondary"
                type="number"
              />
              <TextField
                label="Selling Price"
                value={uom.price}
                onChange={(e) => handleUOMChange(index, 'price', e.target.value)}
                variant="outlined"
                color="secondary"
                type="number"
              />
              <Button variant="contained" onClick={() => handleRemoveUOM(index)}>Remove</Button>
            </Stack>
          ))}
          <Button sx={{ mb: 5, mt: 1 }} variant="contained" onClick={handleAddUOM}>Add UOM</Button>
        </div>


        <Button
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          sx={{ mb: 2 }}
        >
          {selectedRowData ? "Update Item/Service" : "Add Item/Service"}
        </Button>
      </form>
      <Button
        onClick={onClose}
        variant="outlined"
        color="error"
        size="large"
        sx={{ mb: 2 }}
      >
        Close
      </Button>
    </div>
  );
};

export default NewItemServiceForm;
